"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.motorUsageType = void 0;
exports.motorUsageType = { "PERSONAL": { "name": { "code": "PERSONAL", "localize": { "en": "For personal", "th": "ใช้ส่วนตัว" } } }, "BUSINESS": { "name": { "code": "BUSINESS", "localize": { "en": "For business", "th": "ใช้ในธุรกิจ" } } } };
